import React from 'react';

import BooksOfAccountsModule from './books-of-accounts.module';
import BooksOfAccounts from 'enums/books-of-accounts';

const BooksOfAccountsCashReceiptModule = () => {
  return (
    <div>
      <BooksOfAccountsModule type={BooksOfAccounts.CashReceipt} />
    </div>
  );
};

export default BooksOfAccountsCashReceiptModule;
